import styled from '@emotion/styled'
import { Logo } from 'app/components/Icons'
import React, { memo, useContext } from 'react'
import { isMobile } from 'react-device-detect'

import { FooterContext } from './index'
import { Social } from './Social'

export const Contacts = memo(function Contacts() {
  const {
    address,
    email,
    facebookURL,
    googleMapsURL,
    instagramURL,
    linkedinURL,
    phone,
  } = useContext(FooterContext) as any

  return (
    <Container>
      <Logo />

      {address ? (
        <>
          <Separator />

          <Anchor href={googleMapsURL} rel="noopener" target="_blank">
            {address}
          </Anchor>
        </>
      ) : null}

      {email ? (
        <>
          <Separator />

          <Anchor
            href={`mailto:${email}`}
            onClick={() => {
              typeof window.gtag !== 'undefined' &&
                window.gtag('event', 'Click', {
                  event_category: 'Website',
                  event_label: 'Email Address',
                })
            }}
          >
            {email}
          </Anchor>
        </>
      ) : null}

      {phone ? (
        <>
          <Separator />

          <Anchor
            href={`tel:${phone}`}
            onClick={() => {
              if (isMobile) {
                typeof window.gtag !== 'undefined' &&
                  window.gtag('event', 'Click', {
                    event_category: 'Website',
                    event_label: 'Phone Number',
                  })
              }
            }}
          >
            {phone}
          </Anchor>
        </>
      ) : null}

      <Social
        facebookURL={facebookURL}
        instagramURL={instagramURL}
        linkedinURL={linkedinURL}
      />
    </Container>
  )
})

const Container = styled.div`
  color: ${({ theme }) => theme.colors.variants.neutralLight5};

  > svg {
    width: 10rem;
    height: 4.5rem;
    fill: ${({ theme }) => theme.colors.variants.neutralLight5};
    margin-bottom: 1.75rem;
  }
`

const Separator = styled.div``

const Anchor = styled.a`
  display: inline-flex;
  color: ${({ theme }) => theme.colors.variants.neutralLight5};
  font-family: ${({ theme }) => theme.fontFamily.paragraph};
  font-size: 1rem;
  font-weight: 300;
  line-height: 1.375rem;
  margin-top: 0.75rem;
  transition: 0.3s ease-in-out;
  &:hover {
    opacity: 0.6;
  }
`
